import React from 'react';
import styles from './Funnel.module.scss';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ReactComponent as BlueExpandIcon } from 'assets/blueExpand.svg';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface FunnelData {
  funnelData: any;
  setPipelineIsClicked: (isClicked: boolean) => void;
}

const Funnel: React.FC<{funnelData: any, setPipelineIsClicked: (isClicked: boolean) => void}> = ({funnelData, setPipelineIsClicked}) => {
  return (
    <div className={styles.funnelContainer}>
      <div className={`${styles.section} `}>
        <div className={styles.topText}>
          LEADS
        </div>
        
        <div className={styles.leads}>
          <div className={styles.accounts}>
            <div className={styles.accountsText}>
              {funnelData?.lead} 
            </div>
            <div className={styles.accountsSubText}>
              accounts
            </div>
          </div>

        </div>
        {/*
        <div className={styles.middlePercentage}>
          {Math.round((funnelData?.prospect/funnelData?.lead) * 100)}%
        </div>
        */}
      </div>
{/* 
      <div style={{width: `${funnelData.funnelPercentages.prospects}%`}} className={`${styles.section} ${styles.prospects}`}> */}
      <div style={{width: `70%`}} className={`${styles.section} ${styles.prospects}`}>
        <div className={styles.topText}>
          PROSPECTS
        </div>
        
        <div className={styles.prospects}>
          <div className={styles.accounts}>
            <div className={styles.accountsText}>
              {funnelData?.prospect} 
            </div>
            <div className={styles.accountsSubText}>
              accounts
            </div>
          </div>

        </div>
        {/*
        <div className={styles.middlePercentage}>
          {Math.round((funnelData?.won/funnelData?.prospect) * 100)}%
        </div>
        */}
      </div>

      {/* <div style={{width: `${funnelData.funnelPercentages.won}%`}} className={`${styles.section} ${styles.won}`}> */}

      <div style={{width: '50%'}} className={`${styles.section} ${styles.won}`}>
        <div className={styles.topText}>
          CLOSED-WON
        </div>
        
        <div className={styles.won}>
          <div className={styles.accounts}>
            <div className={styles.accountsText}>
              {funnelData?.won} 
            </div>
            <div className={styles.accountsSubText}>
              accounts
            </div>
          </div>

        </div>
        {/*
        <div className={styles.middlePercentage}>
          {Math.round((funnelData?.opportunities/funnelData?.won) * 100)}%
        </div>
        */}
      </div>
    {/* 
      <div style={{width: `${funnelData.funnelPercentages.opportunities}%`}} className={`${styles.section} ${styles.opportunities}`}> 
      <div style={{width: `100%`}} className={`${styles.section} ${styles.opportunities}`}>
        <div className={styles.topText}>
          OPPORTUNITIES
        </div>
        
        <div className={styles.opportunities}>
          <div className={styles.accounts}>
            <div className={styles.accountsText}>
              {funnelData?.opportunities} 
            </div>
            <div className={styles.accountsSubText}>
              accounts
            </div>
          </div>
        </div>
      </div>

      <div onClick={() => setPipelineIsClicked(true)} style={{width: `90%`}} className={` ${styles.pipeline}`}>
        <div className={styles.pipelineComponent}>
          <div className={styles.pipelineText}>
            ${funnelData?.pipelineData?.pipeline?? 2.2}M
          </div>        
          <div style={{color: '#4F7D9C', fontSize: '10px', textAlign: 'center'}}>
            See pipeline
          </div>

        </div>
        <div style={{alignSelf: 'center', paddingLeft: '10px'}}>
          <BlueExpandIcon width={20} height={20} style={{ color: '#4F7D9C' }} />
        </div>
      </div>
      */}
    </div>
  );
};

export { Funnel };
export default Funnel; 